/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { OfficeRoleDto } from './office-role.dto';

export const OfficeRoleMapper = entity<OfficeRoleDto>();
